import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const loginWithGoogle = (email, name, profilePicUrl, countryName, countryCd, countryCurrCd, countryTelCd, location, latitude, longitude, captchaToken ) => {
    return new Promise((resolve, reject) => {
        const data = {
            email,
            userfname: name,
            userlname: "",
            gender: "",
            accountType: "General",
            activeInd: "Y",
            profilePic: profilePicUrl,
            countryName,
            countryCd,
            countryCurrCd,
            countryTelCd,
            location: location ?? countryName, // fallback if location is undefined
            userLat: latitude,
            userLng: longitude,
            captchaToken
        };
        
        axios({
            method : "POST",
            url :  api_url + "/public/LoginGoogleUser",
            data: JSON.stringify(data),
            headers: { "Content-Type": "application/json" },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}